import DataExplorerPage from './containers/DataExplorerPage'
export default DataExplorerPage
